<button *ngIf="options.closeButton" (click)="remove()" class="toast-close-button" aria-label="Close">
   <span aria-hidden="true">&times;</span>
</button>
<h3>{{ 'notification.reachability.title' | translate }}</h3>
<p>{{ 'notification.reachability.description' | translate }}</p>
<ul>
   <li *ngIf="isUnreachableBecauseOfUserstate$ | async">
      {{ 'notification.reachability.because_of_userstatus' | translate }}
   </li>
   <li *ngIf="isUnreachableBecauseOfSkills$ | async">
      {{ 'notification.reachability.because_not_logged_on_to_any_skill' | translate }}
   </li>
   <li *ngIf="isUnreachableBecauseOfAgent$ | async">
      {{ 'notification.reachability.because_of_deactivated' | translate }}
   </li>
</ul>
<button
   *ngIf="(isUnreachableBecauseOfSkills$ | async) || (isUnreachableBecauseOfUserstate$ | async)"
   (click)="resolve()"
   kendoButton
   style="float: right"
>
   <fa-icon class="sam-margin-right green" [icon]="resolveIcon"></fa-icon>
   <div class="sam-button-text">
      {{ 'notification.reachability.resolve_button_Text' | translate }}
   </div>
</button>
<div *ngIf="options.progressBar">
   <div class="toast-progress" [style.width]="width + '%'"></div>
</div>
